<template>
  <v-layout class="main-wrapper" column>
    <v-app-bar color="transparent" flat>
      <v-btn class="btn-icon" icon @click="handleDrawer()">
        <v-icon>
          {{ drawer ? "mdi-menu-open" : "mdi-menu-close" }}
        </v-icon>
      </v-btn>

      <v-toolbar-title class="pl-2">
        Boas vindas, {{ _user?.name ? _user.name.split(" ")[0] : "" }}
      </v-toolbar-title>

      <v-spacer />

      <v-avatar class="mr-4" size="2.5rem" color="neutral2">
        <v-icon color="white">mdi-account-outline</v-icon>
      </v-avatar>

      <v-icon color="neutral8" small @click="signOut()"> mdi-logout </v-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      class="side-drawer rounded-r-xl"
      color="neutral1"
      floating
      app
    >
      <div class="d-flex flex-column fill-height">
        <div class="d-flex justify-center align-center py-4">
          <v-img
            :src="$settings?.profile?.logo"
            class="mr-2"
            max-width="2rem"
            height="2rem"
            contain
          />

          <span class="text-h6"> Backoffice </span>
        </div>

        <v-list class="py-0 pb-16" color="transparent" dense nav>
          <template v-for="(item, i) in _routes">
            <div :key="i">
              <template v-if="item.section">
                <v-divider class="my-4" />

                <div
                  class="ml-2 text-subtitle-2 font-weight-bold neutral8--text mb-2"
                >
                  {{ item.title }}
                </div>

                <router-link
                  v-for="(route, n) in item.routes"
                  v-slot="{ href, navigate, isActive }"
                  :to="route.path"
                  :key="n"
                  custom
                >
                  <v-list-item class="mb-2" :href="href" @click="navigate">
                    <v-list-item-icon class="mr-2">
                      <v-icon
                        :color="isActive ? 'primary' : 'neutral8'"
                        :size="item.iconSize || '1.25rem'"
                      >
                        {{ route.icon }}
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-title
                      :class="{
                        'primary--text': isActive,
                        'neutral8--text': !isActive,
                      }"
                    >
                      {{ route.label }}
                    </v-list-item-title>
                  </v-list-item>
                </router-link>
              </template>

              <template v-else>
                <router-link
                  v-slot="{ href, navigate, isActive }"
                  :to="item.path"
                  custom
                >
                  <v-list-item
                    class="mb-2 rounded-lg"
                    :class="isActive ? 'neutral2' : 'transparent'"
                    :href="href"
                    @click="navigate"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon
                        :color="isActive ? 'primary' : 'neutral8'"
                        :size="item.iconSize || '1.25rem'"
                      >
                        {{ item.icon }}
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-title
                      :class="{
                        'primary--text': isActive,
                        'neutral8--text': !isActive,
                      }"
                    >
                      {{ item.label }}
                    </v-list-item-title>
                  </v-list-item>
                </router-link>
              </template>
            </div>
          </template>
        </v-list>
      </div>
    </v-navigation-drawer>

    <router-view />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Main",

  data() {
    return {
      drawer: true,
    };
  },

  computed: {
    ...mapGetters({
      _user: "user",
    }),

    _title() {
      return this.$settings?.profile?.name;
    },

    _routes() {
      return [
        {
          icon: "fas fa-home",
          label: "Início",
          path: "/home",
          iconSize: "1rem",
        },
        {
          icon: "mdi-account-group",
          label: "Usuários",
          path: "/users",
        },
        {
          icon: "mdi-swap-vertical",
          label: "Movimentações financeiras",
          path: "/moves",
        },
        {
          icon: "mdi-bank-outline",
          label: "Solicitações de saque",
          path: "/withdraws",
        },
        {
          icon: "mdi-arrow-down",
          label: "Depósitos",
          path: "/deposits",
        },
        {
          icon: "fas fa-sms",
          label: "Envio de SMS",
          path: "/sms",
        },
        {
          icon: "fas fa-envelope",
          label: "Envio de E-mail",
          path: "/email",
        },
        {
          section: true,
          title: "Jogos e Premiações",
          routes: [
            {
              icon: "mdi-file-word-box",
              label: "Palavra Premiada",
              path: "/prize-word",
            },
            {
              icon: "mdi-head-remove-outline",
              label: "Jogo da Forca",
              path: "/hangman",
            },
            {
              icon: "fas fa-crosshairs",
              label: "Sorteios",
              path: "/raffles",
            },
            {
              icon: "fas fa-life-ring",
              label: "Roleta premiada",
              path: "/wheels",
            },
            {
              icon: "mdi-progress-star",
              label: "Jogos pagos",
              path: "/draws/scratches",
            },
            {
              icon: "mdi-gift-open-outline",
              label: "Promoções",
              path: "/promotions",
            },
            {
              icon: "mdi-truck-cargo-container",
              label: "Remessas",
              path: "/shipments",
            },
          ],
        },
        {
          section: true,
          title: "Patrocinador",
          routes: [
            /*  {
              icon: "mdi-view-dashboard-outline",
              label: "Dashboard",
              path: "/sponsor/dashboard",
            }, */
            {
              icon: "fas fa-video",
              label: "Campanhas",
              path: "/sponsor/campaigns",
            },
            /*  {
              icon: "mdi-text-box-search-outline",
              label: "Relatórios de públicidade",
              path: "/sponsor/reports",
            }, */
          ],
        },
        {
          section: true,
          title: "Afiliados",
          routes: [
            {
              icon: "fas fa-hands-helping",
              label: "Afiliados",
              path: "/affiliates",
            },
            /* {
              icon: "mdi-view-dashboard-outline",
              label: "Dashboard",
              path: "/affiliates/dashboard",
            },
            {
              icon: "mdi-text-box-search-outline",
              label: "Relatórios de afiliados",
              path: "/affiliates/reports",
            }, */
          ],
        },
        {
          section: true,
          title: "Configurações",
          routes: [
            {
              icon: "fa-wrench",
              label: "Definições da plataforma",
              path: "/settings",
            },
            {
              icon: "fa-store",
              label: "Gerenciar loja",
              path: "/store",
            },
            {
              icon: "mdi-chart-timeline-variant",
              label: "Trilhas de recompensas",
              path: "/milestones",
            },
            {
              icon: "fa-images",
              label: "Gerenciar Banners",
              path: "/banners",
            },
          ],
        },
      ];
    },
  },

  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$root.$emit("sign-out");
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
